import { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  Box
} from "@mui/material";
import ArgonButton from "components/ArgonButton";
import ArgonTypography from "components/ArgonTypography";

function CreateRoomModal({ open, onClose, onCreateRoom }) {
  const [roomData, setRoomData] = useState({
    name: "",
    type: "group",
    description: "",
    is_private: false
  });

  const handleSubmit = async () => {
    if (!roomData.name.trim()) return;
    
    try {
      await onCreateRoom(roomData);
      setRoomData({
        name: "",
        type: "group", 
        description: "",
        is_private: false
      });
      onClose();
    } catch (error) {
      console.error("Failed to create room:", error);
    }
  };

  const handleChange = (field) => (event) => {
    setRoomData(prev => ({
      ...prev,
      [field]: event.target.value
    }));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <ArgonTypography variant="h5" fontWeight="bold">
          Create New Chat Room
        </ArgonTypography>
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Room Name"
            fullWidth
            variant="outlined"
            value={roomData.name}
            onChange={handleChange('name')}
            sx={{ mb: 2 }}
          />
          
          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel>Room Type</InputLabel>
            <Select
              value={roomData.type}
              onChange={handleChange('type')}
              label="Room Type"
            >
              <MenuItem value="group">Group Chat</MenuItem>
              <MenuItem value="support">Support Channel</MenuItem>
              <MenuItem value="vendor">Vendor Communication</MenuItem>
            </Select>
          </FormControl>
          
          <TextField
            margin="dense"
            label="Description (Optional)"
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            value={roomData.description}
            onChange={handleChange('description')}
            sx={{ mb: 2 }}
          />
          
          <FormControlLabel
            control={
              <Checkbox
                checked={roomData.is_private}
                onChange={(e) => setRoomData(prev => ({ ...prev, is_private: e.target.checked }))}
              />
            }
            label="Private Room (Invite Only)"
          />
        </Box>
      </DialogContent>
      
      <DialogActions>
        <ArgonButton onClick={onClose}>
          Cancel
        </ArgonButton>
        <ArgonButton
          variant="gradient"
          color="info"
          onClick={handleSubmit}
          disabled={!roomData.name.trim()}
        >
          Create Room
        </ArgonButton>
      </DialogActions>
    </Dialog>
  );
}

CreateRoomModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateRoom: PropTypes.func.isRequired
};

export default CreateRoomModal;